import { GlobalResponseObject } from "@schemax-whatsapp/shared-models/common";
import { SchemaxEmployeesModel } from "./schemax-employees.model";

export class SchemaxEmployeesResponse extends GlobalResponseObject {
    data?: SchemaxEmployeesModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SchemaxEmployeesModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}